import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import { CalendarClock, Layers } from "lucide-react";
import { getEventSubEvents } from "../../services/UserServices/UserService";
import PageTitle from "../layouts/PageTitle";
import { PageContentLoader } from "../components/TableLoader";

const EventListingSubEvents = () => {
  const [subEvents, setSubEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const historyData = location.state;

  useEffect(() => {
    const getSubEvents = async () => {
      try {
        setLoading(true);
        const res = await getEventSubEvents(id);
        setSubEvents(res?.data?.data?.subEvents || []);
      } catch (error) {
        console.error(error?.response?.data?.message);
        setSubEvents([]);
      } finally {
        setLoading(false);
      }
    };
    if (id) getSubEvents();
  }, [id]);

  const formatDateTime = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="qx-page">
      <PageTitle
        breadcrumbs={[
          { label: "Event List", path: "/events" },
          {
            label: historyData?.name ? historyData?.name : "Event",
            path: `/event_details/${id}`,
            state: { tension: historyData },
          },
          { label: "Sub Events" },
        ]}
      />

      {loading ? (
        <PageContentLoader message="Loading sub events..." />
      ) : !subEvents?.length ? (
        <div className="qx-empty-state qx-empty-state--rich">
          <div className="qx-empty-state__icon">
            <Layers size={28} />
          </div>
          <p className="qx-empty-state__title">No sub events available</p>
          <p className="qx-empty-state__desc mb-0">
            Sub events for this occasion will appear here once they are added.
          </p>
        </div>
      ) : (
        <div className="qx-subevent-grid">
          {subEvents.map((s, i) => (
            <Card key={s?._id || i} className="qx-subevent-card">
              <Card.Body>
                <div className="qx-subevent-card__badge">Sub event</div>
                <h3 className="qx-subevent-card__title">{s?.name || "Untitled"}</h3>
                <div className="qx-subevent-card__meta">
                  <CalendarClock size={15} />
                  <span>{formatDateTime(s?.dateTime)}</span>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default EventListingSubEvents;
